
import { BallPiece, Vector2D, ShapeType } from '@/types';
import { ShapeUtils } from '@/logic/physics/ShapeUtils';
import { random } from '@/lib/random';

export const BallBreakAnimation = {
  createPieces: (
    pos: Vector2D,
    radius: number,
    color: string,
    count: number,
    shape: ShapeType,
    now: number,
    duration: number
  ): BallPiece[] => {
    const pieces: BallPiece[] = [];
    for (let i = 0; i < count; i++) {
      const angle = random.range(0, Math.PI * 2);
      const dist = random.range(0, radius * 0.8);
      const speed = random.range(3, 11);
      
      // Shard position offset from center
      const offsetX = Math.cos(angle) * dist;
      const offsetY = Math.sin(angle) * dist;

      pieces.push({
        id: `piece-${now}-${i}`,
        pos: { x: pos.x + offsetX, y: pos.y + offsetY },
        vel: {
          x: (Math.cos(angle) * speed) + random.range(-3, 3),
          y: (Math.sin(angle) * speed) - 10 + random.range(-3, 3) // Stronger upward burst
        },
        radius: radius * random.range(0.1, 0.4),
        color,
        startTime: now,
        duration,
        angle: random.range(0, Math.PI * 2),
        spin: random.range(-0.3, 0.3),
        shape: (['TRIANGLE', 'SQUARE', 'PENTAGON', 'HEXAGON', 'GEM'] as ShapeType[])[random.int(0, 4)]
      });
    }
    return pieces;
  },

  updatePieces: (
    pieces: BallPiece[],
    deltaTime: number,
    gravity: number,
    now: number
  ): BallPiece[] => {
    const dt = deltaTime / 16.67;
    return pieces.filter(p => now - p.startTime < p.duration).map(p => {
      p.vel.y += gravity * dt;
      p.pos.x += p.vel.x * dt;
      p.pos.y += p.vel.y * dt;
      p.angle += p.spin * dt;
      return p;
    });
  },

  drawPieces: (
    ctx: CanvasRenderingContext2D,
    pieces: BallPiece[],
    now: number
  ) => {
    pieces.forEach(p => {
      const elapsed = now - p.startTime;
      const progress = elapsed / p.duration;
      const alpha = 1 - progress;

      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(p.pos.x, p.pos.y);
      ctx.rotate(p.angle);
      ctx.fillStyle = p.color;

      ctx.beginPath();
      ShapeUtils.traceShape(ctx, { x: 0, y: 0 }, p.shape, p.radius);
      ctx.fill();

      ctx.restore();
    });
  }
};
